// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.PaymentMethod = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.PaymentMethod = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var PaymentMethod = _exports.PaymentMethod = function PaymentMethod(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.625 5.2475V5C15.625 2.985 14.515 1.875 12.5 1.875H4.16667C2.9025 1.875 1.875 2.9025 1.875 4.16667V15C1.875 17.015 2.985 18.125 5 18.125H15C17.015 18.125 18.125 17.015 18.125 15V8.33333C18.125 6.5375 17.2433 5.46083 15.625 5.2475ZM16.875 13.125H13.75C12.9458 13.125 12.2917 12.4708 12.2917 11.6667C12.2917 10.8625 12.9458 10.2083 13.75 10.2083H16.875V13.125ZM4.16667 3.125H12.5C13.8142 3.125 14.375 3.68583 14.375 5V5.20833H4.16667C3.5925 5.20833 3.125 4.74083 3.125 4.16667C3.125 3.5925 3.5925 3.125 4.16667 3.125ZM15 16.875H5C3.68583 16.875 3.125 16.3142 3.125 15V6.20748C3.4375 6.36748 3.79167 6.45833 4.16667 6.45833H15C16.3142 6.45833 16.875 7.01917 16.875 8.33333V8.95833H13.75C12.2567 8.95833 11.0417 10.1733 11.0417 11.6667C11.0417 13.16 12.2567 14.375 13.75 14.375H16.875V15C16.875 16.3142 16.3142 16.875 15 16.875ZM14.175 10.8333H14.1833C14.6442 10.8333 15.0167 11.2067 15.0167 11.6667C15.0167 12.1267 14.6442 12.5 14.1833 12.5C13.7233 12.5 13.3458 12.1267 13.3458 11.6667C13.3458 11.2067 13.715 10.8333 14.175 10.8333Z",
      fill: "#212B36"
    }));
  };
});
